module.exports = __webpack_public_path__ + "static/media/kc-service.782ddfe1.png";